/** Ref-count helper so overlapping async actions keep the overlay visible. */
export function createLoadingCounter() {
  let count = 0;
  let listeners = new Set<(active: boolean) => void>();

  const notify = () => {
    const active = count > 0;
    listeners.forEach((l) => l(active));
  };

  return {
    get count() {
      return count;
    },
    subscribe(listener: (active: boolean) => void) {
      listeners.add(listener);
      listener(count > 0);
      return () => {
        listeners.delete(listener);
      };
    },
    start() {
      count += 1;
      notify();
    },
    stop() {
      count = Math.max(0, count - 1);
      notify();
    },
    reset() {
      count = 0;
      notify();
    },
  };
}
